import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { flowRight as compose } from 'lodash';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import CustomPagination from '../../CustomPagination';
import CommonTable from '../../CommonTable/CommonTable';
import Loader from '../../Loader/Loader'
import { dateFormat } from '../../../config';

import ReportManagementQuery from './ReportManagement.graphql';
import { withQuery } from '../../../hoc/withGraphql';
import { censorEmail, decode } from '../../../helpers/secureEmail';
import { demoRestrictionEncode } from '../../../helpers/DemoRestriction/demoRestriction';
import { getDynamicReportType } from '../../../helpers/GetDynamicItemName/dynamicReportTypeHelper';

import s from './ReportManagement.css';
import messages from '../../../locale/jsonMessages';

class ReportManagement extends React.Component {

    static propTypes = {
        title: PropTypes.string.isRequired,
        data: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.number.isRequired,
            userId: PropTypes.number.isRequired,
            reporterId: PropTypes.string.isRequired,
            reporterType: PropTypes.string.isRequired,
        })),
    };

    static defaultProps = {
        data: []
    };

    constructor(props) {
        super(props);
        this.state = {
            value: '',
            currentPage: 1,
            searchList: '',
            typing: false,
            typingTimeout: 0,
            isRestrict: false,
        }
        this.paginationData = this.paginationData.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    async componentDidMount() {
        const { demoRestrictionEncode } = this.props;
        const isRestrict = await demoRestrictionEncode();
        this.setState({ isRestrict });
    }

    paginationData(currentPage) {
        const { reportUserManagement: { refetch }, setStateVariable } = this.props;
        let variables = { currentPage };
        setStateVariable(variables);
        refetch(variables);
    }
    handleClick(searchList) {
        const { reportUserManagement: { refetch }, setStateVariable } = this.props;
        const { currentPage } = this.state;
        let variables = {
            currentPage: 1,
            searchList: searchList
        };
        setStateVariable(variables);
        refetch(variables);
    }
    handleSearchChange = (e) => {
        const self = this;
        if (self.state.typingTimeout) {
            clearTimeout(self.state.typingTimeout);
        }
        self.setState({
            searchList: e.target.value,
            typing: false,
            typingTimeout: setTimeout(function () {
                self.handleClick(self.state.searchList);
            }, 450)
        });
    }

    thead = () => {
        const { formatMessage } = this.props.intl;
        return [
            { data: formatMessage(messages.idLabel) },
            { data: formatMessage(messages.reporterName) },
            { data: formatMessage(messages.reporterEmail) },
            { data: formatMessage(messages.userNameLabel) },
            { data: formatMessage(messages.userEmailLabel) },
            { data: formatMessage(messages.reportTitleLabel) },
            { data: formatMessage(messages.transferDate) }
        ]
    };

    tbody = (props) => {
        const { reportUserManagement: { loading, reportUserManagement } } = props;
        const { formatMessage, locale } = this.props.intl;
        const { isRestrict } = this.state;

        return reportUserManagement?.reportsData.map((value) => {
            let reportType = value?.dynamicReportType && value?.dynamicReportType.length > 0 ? getDynamicReportType({ value: value, locale, data: JSON.parse(value?.dynamicReportType) }) : value?.reportType;
            return {
                id: value?.id,
                data: [
                    { data: value.id },
                    {
                        data: value?.reporterData ? value?.reporterData?.displayName : <FormattedMessage  {...messages.userDeletedLabel} />
                    },
                    {
                        data: value?.reporterData ? <div><a href={"/users/show/" + value.userProfileId.profileId} target="_blank">
                            {!isRestrict ? decode(value?.reporterEncryptEmail?.email) : censorEmail(decode(value?.reporterEncryptEmail?.email))}
                        </a></div> : <FormattedMessage  {...messages.userDeletedLabel} />
                    },
                    {
                        data: value?.userData ? value.userData.displayName : <FormattedMessage  {...messages.userDeletedLabel} />
                    },
                    {
                        data: value?.userData ? <div><a href={"/users/show/" + value.userData.profileId} target="_blank">
                            {!isRestrict ? decode(value?.userEncryptEmail?.email) : censorEmail(decode(value?.userEncryptEmail?.email))}
                        </a></div> : <FormattedMessage  {...messages.userDeletedLabel} />
                    },
                    { data: reportType },
                    { data: moment(parseInt(value.createdAt)).format(dateFormat?.shortDateFormat) }
                ]
            }
        })
    }


    render() {
        const { formatMessage } = this.props.intl;
        const { reportUserManagement: { loading, reportUserManagement }, currentPage } = this.props;

        if (loading) {
            return <Loader type={"text"} />
        }

        return (
            <div>
                <CommonTable
                    thead={this.thead}
                    tbody={() => this.tbody(this.props)}
                    title={formatMessage(messages.reportManagement)}
                    isSearch
                    onSearch={this.handleSearchChange}
                />
                {
                    !loading && reportUserManagement?.reportsData?.length > 0 &&
                    <CustomPagination
                        total={reportUserManagement.count}
                        currentPage={currentPage}
                        defaultCurrent={1}
                        defaultPageSize={10}
                        change={this.paginationData}
                        paginationLabel={formatMessage(messages.messages)}
                    />
                }
            </div>
        );
    }

}

const mapState = (state) => ({
});

const mapDispatch = {
    demoRestrictionEncode
};

export default compose(
    injectIntl,
    withStyles(s),
    connect(mapState, mapDispatch),
    withQuery(ReportManagementQuery, {
        name: 'reportUserManagement',
        options: (props) => ({
            variables: {
                currentPage: 1,
                searchList: ''
            },
            fetchPolicy: 'network-only',
            ssr: false
        })
    })
)(ReportManagement);